import {
    SCHIBSTED_ACCOUNT_EVENT_LOGIN,
    SCHIBSTED_ACCOUNT_EVENT_LOGOUT,
    SCHIBSTED_ACCOUNT_EVENT_NOTLOGGEDIN,
    SCHIBSTED_ACCOUNT_EVENT_VISITOR,
    SCHIBSTED_ACCOUNT_EVENT_SESSION_CHANGE,
    SCHIBSTED_ACCOUNT_EVENT_SESSION_ERROR,
    SCHIBSTED_ACCOUNT_GENERATE_URLS,
    SCHIBSTED_ACCOUNT_HAS_SESSION_ERROR,
    SCHIBSTED_ACCOUNT_INIT_COMPLETE,
} from './types';

const defaultState = () => ({
    initialized: false,
    clientAgreementAccepted: false,
    defaultAgreementAccepted: false,
    displayName: null,
    error: null,
    familyName: null,
    givenName: null,
    loggedIn: false,
    photo: null,
    login: null,
    logout: null,
    accountUrl: null,
    userId: null,
    uuid: null,
});

/* eslint-disable-line import/prefer-default-export */
export const spid = (state = defaultState(), action) => {
    if (action.type === SCHIBSTED_ACCOUNT_INIT_COMPLETE) {
        return {
            ...state,
            ...action.payload,
            initialized: true,
        };
    }

    if (action.type === SCHIBSTED_ACCOUNT_EVENT_LOGIN) {
        return {
            ...state,
            loggedIn: true,
            userId: action.payload.userId,
        };
    }

    if (
        action.type === SCHIBSTED_ACCOUNT_EVENT_LOGOUT
        || action.type === SCHIBSTED_ACCOUNT_EVENT_NOTLOGGEDIN
    ) {
        return {
            ...state,
            clientAgreementAccepted: false,
            defaultAgreementAccepted: false,
            displayName: null,
            familyName: null,
            givenName: null,
            loggedIn: false,
            photo: null,
            userId: null,
            uuid: null,
        };
    }

    if (action.type === SCHIBSTED_ACCOUNT_EVENT_VISITOR) {
        return state;
    }

    if (action.type === SCHIBSTED_ACCOUNT_EVENT_SESSION_CHANGE) {
        const {
            clientAgreementAccepted = null,
            defaultAgreementAccepted = null,
            displayName = null,
            familyName = null,
            givenName = null,
            photo = null,
            sig = null,
            uuid = null,
        } = action.payload;

        return {
            ...state,
            clientAgreementAccepted,
            defaultAgreementAccepted,
            displayName,
            familyName,
            givenName,
            photo,
            sig,
            uuid,
        };
    }

    if (action.type === SCHIBSTED_ACCOUNT_HAS_SESSION_ERROR) {
        return {
            ...state,
            error: {
                ...state.error,
                session: action.payload,
            },
        };
    }

    if (action.type === SCHIBSTED_ACCOUNT_EVENT_SESSION_ERROR) {
        return {
            ...state,
            error: {
                ...state.error,
                event: action.payload,
            },
        };
    }

    if (action.type === SCHIBSTED_ACCOUNT_GENERATE_URLS) {
        return {
            ...state,
            ...action.payload,
        };
    }

    return state;
};
/* eslint-enable import/prefer-default-export */
